export const document = {
	general: "general",
	user: "praticien",
	office: "cabinet",
	patient: "patient",
	consultation: "consultation",
	invoice: "facture",
}
